import * as React from 'react';

import { AppCrashNotification } from './AppCrashNotification';

type Props = {
  children?: React.ReactNode;
};

type State = {
  error?: Error;
  errorInfo: any;
};

export class ErrorBoundary extends React.Component<Props, State> {
  public readonly state: State = { error: undefined, errorInfo: undefined };

  public componentDidCatch(error: Error, errorInfo: unknown): void {
    // eslint-disable-next-line no-console
    console.log('errorInfo', errorInfo);

    this.setState(() => ({
      error,
      errorInfo,
    }));
  }

  public render(): React.ReactNode {
    const { error } = this.state;
    const { children } = this.props;
    if (error) {
      return <AppCrashNotification message={error.message} />;
    }

    return children;
  }
}
